export const domain = 'https://api.test.tis.coke.com'
export const tempDomain = 'https://pfas.api.test.tis.coke.com'
export const azureClientId = 'asdf'
export const azureTenantId = 'eb36d020-2c35-44de-bc7a-554cc979b26d'
export const apiKey = 'asdf'
export const auth = 'asdf'
export const stage = 'test'

